import React from "react";

import type { TextProps } from "./text.types";

const Text = ({ children, size = "md", style, ...props }: TextProps) => (
  <p className={`body-text-${size}`} style={style} {...props}>
    {children}
  </p>
);

export default Text;
